import stateGlob from './state';
const albumData = stateGlob.albumData;

const Album = (props) => {
	//info about the album
	const album = props.album;
	const name = album.name;
	const artist = album.artist;
	const release = album.release;
	const library = album.library;
	const songCount = album.songcount;
	//the function that changes the page
	const increment = props.inc;
	const index = albumData.findIndex(alb => alb.name === name) + 1;
	//function is used for image onClick
	const changePage = () => {
		//that global variable that can be accessed anywhere, then used in the increment function to change the page
		stateGlob.state = index;
		increment();
	}
	//the items to be displayed in the table
	const dataStrings = ["artist -----------", "release date ---", "date added ----", "songs -----------"];
	const data = [artist, release, library, songCount];
	//displays the album cover, artist name and a table of information based on above variables
	return(
		<div className="cell">
			<div>
				<img src = {require(`./albums/${name}.png`)} alt = {`./albums/${name}.png`} height = '222pt' onClick={changePage}/><br/>
				<span><b>{name}</b></span>
			</div>
			<table>
				<tbody>
					{data.map((dat, i) => <tr key = {i}><td>✧</td><td><b>{dataStrings[i]}</b></td><td>{data[i]}</td></tr>)}
				</tbody>
			</table>
		</div>						
	)
}

const App = (props) => {
	// 0: default, 1: album name, 2: artist, 3: song count
	//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
	if(props.sortOrder === 1) {
		albumData.sort((a, b) => {
			if (a.name < b.name) {
			  return -1;
			} return 0;
		});
	} else if(props.sortOrder === 2) {
		albumData.sort((a, b) => {
			if (a.artist < b.artist) {
			  return -1;
			} return 0;
		});
	} else if(props.sortOrder === 3) {
		albumData.sort((a, b) => {
			if(a.songcount < b.songcount) {
			  return -1;
			} return 0;
		});
	}
	//display is flex so it fills in nicely in the grid
	return (
		<div className="container">
			<div className="header">emma's favorite albums (made with react!)</div>
			<div className="grid">
				{albumData.map((album, i) => <Album album = {album} inc = {props.inc} key = {i}/>)}
			</div>
			
		</div>
	)
}
export default App